// extracted by mini-css-extract-plugin
export default {"hiddenField":"RedirectForm_hiddenField__4JUBJ","freeTextarea":"RedirectForm_freeTextarea__28rxG"};